import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const comparisons = [
  { titleKey: 'diff_1_title', descKey: 'diff_1_desc', icon: 'ri-percent-line', color: 'text-emerald-600' },
  { titleKey: 'diff_2_title', descKey: 'diff_2_desc', icon: 'ri-user-heart-line', color: 'text-amber-600' },
  { titleKey: 'diff_3_title', descKey: 'diff_3_desc', icon: 'ri-eye-2-line', color: 'text-emerald-600' },
  { titleKey: 'diff_4_title', descKey: 'diff_4_desc', icon: 'ri-flashlight-line', color: 'text-amber-600' },
];

export default function WhyDifferent() {
  const { t } = useTranslation();

  return (
    <section className="py-24 bg-[#FCFAFD] px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left: Content */}
          <div>
            <p className="text-xs font-semibold text-[#4F2D63] uppercase tracking-widest mb-4">
              Why Choose Us
            </p>
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6 leading-tight">
              {t('different_title')}
            </h2>
            <p className="text-base text-gray-500 leading-relaxed mb-8 max-w-lg">
              {t('different_body')}
            </p>

            {/* Visual comparison */}
            <div className="bg-[#F8F3FB] rounded-2xl p-6 mb-8">
              <div className="grid grid-cols-2 gap-0">
                <div className="pr-6 border-r border-[#E9D9F2]">
                  <p className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-4">Traditional Loans</p>
                  {[
                    '20%+ Annual Interest Rate (APR)',
                    '3–6 months of paperwork',
                    'Automated, no human support',
                    'Hidden fees & early-pay penalties',
                    'Rigid, opaque qualification rules',
                  ].map((item) => (
                    <div key={item} className="flex items-center gap-2 mb-2.5">
                      <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                        <i className="ri-close-circle-line text-red-400 text-sm"></i>
                      </div>
                      <span className="text-xs text-gray-500">{item}</span>
                    </div>
                  ))}
                </div>
                <div className="pl-6">
                  <p className="text-xs font-bold text-[#4F2D63] uppercase tracking-wider mb-4">Kailac</p>
                  {[
                    '0% Interest for 12 months*',
                    '2–5 weeks, qualified applicants',
                    'Expert human advisors, always',
                    'Transparent pricing, no surprises',
                    'Guided step-by-step process',
                  ].map((item) => (
                    <div key={item} className="flex items-center gap-2 mb-2.5">
                      <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                        <i className="ri-check-line text-[#0F766E] text-sm"></i>
                      </div>
                      <span className="text-xs text-gray-700 font-medium">{item}</span>
                    </div>
                  ))}
                </div>
              </div>
              <p className="text-xs text-gray-400 italic mt-4 pt-4 border-t border-[#E9D9F2]">
                *For qualified applicants. Subject to eligibility and lender requirements. Results not guaranteed.
              </p>
            </div>

            <Link
              to="/why-us"
              className="inline-flex items-center gap-2 px-7 py-3.5 rounded-xl border-2 border-[#4F2D63] text-[#4F2D63] font-semibold text-sm hover:bg-[#F8F3FB] transition-colors cursor-pointer whitespace-nowrap"
            >
              {t('different_cta')}
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          {/* Right: Differentiators */}
          <div className="space-y-4">
            {comparisons.map(({ titleKey, descKey, icon, color }) => (
              <div
                key={titleKey}
                className="flex items-start gap-4 bg-[#F8F3FB] rounded-xl p-6 border border-[#E9D9F2]"
              >
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-white border border-[#E9D9F2] flex-shrink-0">
                  <i className={`${icon} ${color} text-lg`}></i>
                </div>
                <div>
                  <h3 className="text-base font-semibold text-gray-900 mb-1">{t(titleKey)}</h3>
                  <p className="text-sm text-gray-500 leading-relaxed">{t(descKey)}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
